import React from "react";
import useFloweyAutoRefetchMutation from "./useFloweyAutoRefetchMutation";
import {
	updateAttendeesAccessRights,
	getAttendeesActionTaskStatus
} from "../api/attendees-actions";

export const useUpdateAttendeesAccessRights = (
	organizationId,
	options = {}
) => {
	const mutationFn = React.useCallback(
		payload =>
			updateAttendeesAccessRights({
				organizationId,
				payload
			}).then(({ response }) => response),
		[organizationId]
	);

	const queryFn = React.useCallback(
		taskId =>
			getAttendeesActionTaskStatus({
				organizationId,
				taskId
			}).then(({ response }) => response),
		[organizationId]
	);

	return useFloweyAutoRefetchMutation(mutationFn, queryFn, options);
};
